import { CaseStatus } from 'lemunzo-api';

/**
 * Helper function to uniformly decide whether a case is open to clients or not.
 * @param status case status to be examined
 */
export function isCaseOpenToClients(status: CaseStatus): boolean {
    return (
        status === CaseStatus.ClientZoneOnly ||
        status === CaseStatus.FullyEnabled
    );
}
